import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {FormGroupComponent} from '../../../components/form-inputs/form-group/form-group.component';
import {FormErrorService} from '../../../services/form-error.service';
import {AuthenticationService} from '../../../services/api/authentication-service';
import {ToastrService} from 'ngx-toastr';
import {PasswordResetData} from '../../../entities/password-reset-data.entity';

@Component({
  selector: 'app-auth-reset-password',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    FormGroupComponent,
    RouterLink
  ],
  templateUrl: './reset.component.html'
})
export class ResetComponent implements OnInit {
  public form = new FormGroup({
    token: new FormControl<string>(''),
    email: new FormControl<string>(''),
    password: new FormControl<string>('', [Validators.required]),
    password_confirmation: new FormControl<string>('', [Validators.required]),
  });

  public constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly toastrService: ToastrService,
    private readonly formErrorService: FormErrorService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly translate: TranslateService,
    private readonly router: Router,
  ) {}

  public ngOnInit() {
    this.form.controls.token.setValue(this.activatedRoute.snapshot.params['token'] ?? '');
    this.form.controls.email.setValue(this.activatedRoute.snapshot.queryParams['email'] ?? '');
  }

  public submit() {
    this.form.markAllAsTouched();
    this.form.markAllAsDirty();

    const data = this.form.value as PasswordResetData;

    if (this.form.valid && data) {
      this.authenticationService.setNewPassword(data).subscribe({
        next: () => {
          this.toastrService.success(this.translate.instant('auth.password.reset.success'));
          this.router.navigate(['auth', 'login']).then();
        },
        error: response => this.formErrorService.mapErrorToForm(this.form, response),
      })
    }
  }
}
